import { WifiOff } from 'lucide-react';
import { useOnlineStatus } from '@/hooks/useNetworkAware';
import styles from './online-status-banner.module.less';

export function OnlineStatusBanner() {
  const isOnline = useOnlineStatus();

  if (isOnline) return null;

  return (
    <div className={styles.banner} role="status" aria-live="polite">
      <WifiOff size={16} aria-hidden="true" />
      {/* UIUX-15: only catalogue endpoints are cached offline; memory alone
          cannot back the old "Showing available content" promise. */}
      <span>You&apos;re offline. Some content may be unavailable.</span>
    </div>
  );
}
